import React, { Component } from 'react';
import { Button, Card, Tabs } from 'antd';
import { StrategyTable } from './StrategyTable';
import { inject, observer } from 'mobx-react';
const TabPane = Tabs.TabPane;

@inject('store')
@observer
export class OverviewView extends Component {
    componentDidMount() {
        this.props.store.strategyStore.getOdysseyStrategies();
    }

    render() {
        return (
            <Card
                size="small"
                title={'Mako: Strategies'}
                extra={
                    <Button
                        type="primary"
                        onClick={() => this.props.history.push('/a/strategies/mako/new')}
                    >
                        New Strategy
                    </Button>
                }
                bordered={false}
            >
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Long" key="1">
                        <StrategyTable
                            type={'mako_long'}
                            performDataRefresh={() =>
                                this.props.store.strategyStore.getOdysseyStrategies()
                            }
                        />{' '}
                    </TabPane>
                    <TabPane tab="Short" key="2">
                        <StrategyTable
                            type={'mako_short'}
                            performDataRefresh={() =>
                                this.props.store.strategyStore.getXStragetOdysseyStrategiestegies()
                            }
                        />
                    </TabPane>
                </Tabs>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/MakoStrategies/Overview/index.js